<template>
  <div class="form-question-textarea">
    <textarea
      v-model="innerValue"
      ref="textareaEl"
      class="textarea"
      :class="[options.size]"
      @keydown="textareaKeydown"
      rows="1"
      cols="20"
      placeholder="可通过 shift+回车换行，回车发送；目前仅支持文本内容"
      @focus="onFocus"
      @blur="onBlur"
    ></textarea>

    <!-- 这个的核心，就是用来判断当前光标的高度，然后让文本域的换行可以定位正确 -->
    <div class="mock-div" ref="mockDiv">
      <div class="mock-item" v-for="(item, index) in mockLines" :key="index">{{ item }}</div>
    </div>
  </div>
 
</template>

<script>
export default {
  components: {},
  props: {
    value: {
      type: String,
      default: '',
    },
    focus: Boolean,
    options: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      mockLines: [],
    };
  },
  
  computed: {
    innerValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  watch: {
    innerValue: {
      handler() {
        this.$nextTick(() => {
          this.autoResize();
        });
      },
      immediate: true,
    },
  },
  created() {},
  methods: {
    autoResize() {
      const textarea = this.$refs.textareaEl;
      
      // 先将高度重置为 auto，这样可以避免高度累积的问题
      textarea.style.height = 'auto';
      
      // 通过设置滚动高度来动态调整 textarea 的高度
      textarea.style.height = `${textarea.scrollHeight}px`;
    },
    // 这个的核心，就是用来判断当前光标的高度，然后让文本域的换行可以定位正确，有优化空间，但是实在是没时间弄
    checkCursorPosition() {
      const textarea = this.$refs.textareaEl;

      this.mockLines = textarea.value.substr(0, textarea.selectionStart).split('\n');

      this.$nextTick(() => {
        const lineHeight = 22;
        const mockDiv = this.$refs.mockDiv;
        const cursorTop = mockDiv.scrollHeight - lineHeight;
        const scrollTop = textarea.scrollTop;
        

        if (cursorTop < scrollTop) {
          textarea.scrollTop = cursorTop;
        } else if (cursorTop + lineHeight > scrollTop + textarea.clientHeight) {
          textarea.scrollTop = cursorTop - (textarea.clientHeight - lineHeight);
        }
      });

    },
    textareaKeydown(e) {
      if (e.shiftKey && e.keyCode === 13) {
        // Ctrl+Enter: 添加换行
        const textarea = this.$refs.textareaEl;
        const start = textarea.selectionStart;
        const end = textarea.selectionEnd;

        // 插入换行符
        this.innerValue =
            `${this.innerValue.substring(0, start) 
            }\n${ 
              this.innerValue.substring(end)}`;

        // 更新光标位置
        this.$nextTick(() => {
          textarea.selectionStart = textarea.selectionEnd = start + 1;
          this.checkCursorPosition();
        });

        e.preventDefault(); // 防止默认行为
      } else if (e.keyCode === 13) {
        // enter
        this.$emit('enter');
        e.preventDefault(); // 阻止浏览器默认换行操作
        return false;
      }
    },
    onFocus() {
      this.$emit('update:focus', true);
    },
    onBlur() {
      this.$emit('update:focus', false);
    },
  },
};
</script>

<style lang="less" scoped>
.form-question-textarea{
  width: 100%;
  position: relative;
  font-size: 0;
  .textarea{
    width: 100%;
    border: none;
    background: transparent;
    outline: none;
    font-size: 16px;
    line-height: 22px;
    min-height: 44px;
    max-height: 88px;
    overflow: auto;
    height: auto;
    &.small{
      font-size: 14px;
    }
    &::placeholder{
      color: #C9CDD1;
    }
  }
  .mock-div{
    position: absolute;
    left: -9999px;
    top: -9999px;
    visibility: hidden;
    width: 100%;
    font-size: 14px;
    line-height: 22px;
    max-height: 88px;
    overflow: auto;
    height: auto;
    .mock-item{
      white-space: pre-wrap;
      min-height: 22px;
      word-break: break-all;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/chat-visa/components/form-question-textarea.vue